import dynamic from 'next/dynamic';

export const Switch = dynamic(() => import('antd/lib/switch'), { ssr: false });
